import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const updatePettyCashHodRequestStatus = createAsyncThunk(
	"updatePettyCashHodRequestStatus",
	async ({ requestIds, status_id }, { rejectWithValue }) => {
		try {
			const response = await axiosHttp.put("petty-cash/requests/hod-view", {
				requestIds,
				status_id,
			});
			return response.data;
		} catch (err) {
			if (!err.response) {
				throw err;
			}
			return rejectWithValue(err.response.data);
		}
	},
);

export const approvePettyCashHodRequests = updatePettyCashHodRequestStatus;

const PettyCashHodApprovalSlice = createSlice({
	name: "PettyCashHodApprovalSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashHodApprovalState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(updatePettyCashHodRequestStatus.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});
		builder.addCase(updatePettyCashHodRequestStatus.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});
		builder.addCase(updatePettyCashHodRequestStatus.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export const { resetPettyCashHodApprovalState } = PettyCashHodApprovalSlice.actions;
export default PettyCashHodApprovalSlice.reducer;
